import IconBook from "../../Icons/IconBook";
import IconCalendar from "../../Icons/IconCalendar";
import IconCity from "../../Icons/IconCity";
import IconGlobe from "../../Icons/IconGlobe";
import IconMail from "../../Icons/IconMail";
import IconPuzzle from "../../Icons/IconPuzzle";
import IconUser from "../../Icons/IconUser";
import { Icon } from "@iconify/react";
import { BrijHexColor } from "../../Misc/Constants";
import IconTimer from "../../Icons/IconTimer";

export interface IFormElementWrapper {
  children: any;
  onClick?: any;
  icon?: string;
  small?: boolean;
  prefixText?: string;
}

export default function FormElementWrapper(props: IFormElementWrapper) {
  return (
    <div
      className={`${
        props.small ? "p-1 rounded-xl pl-3 gap-1" : "p-4 rounded-2xl gap-3"
      }
      relative
      flex
      items-center
      border-solid 
      border-2 
      pr-2
      select-none 
      border-brij-LightGrey 
      hover:border-brij-Peach
      bg-brij-White
      text-brij-Black
      w-full
      `}
      onClick={props.onClick}
    >
      {props.icon && (
        <div className="w-6 h-6 grid place-items-center">
          {props.icon === "mail" && <IconMail />}
          {props.icon === "book" && <IconBook />}
          {props.icon === "puzzle" && <IconPuzzle />}
          {props.icon === "user" && <IconUser />}
          {props.icon === "globe" && <IconGlobe />}
          {props.icon === "city" && <IconCity />}
          {props.icon === "calendar" && <IconCalendar />}
          {props.icon === "timer" && <IconTimer />}
          {props.icon === "badge" && (
            <Icon
              icon="uil:award"
              color={BrijHexColor.Peach}
              className="w-6 h-6"
            />
          )}
        </div>
      )}
      {props.prefixText && <div>{props.prefixText}</div>}
      {props.children}
    </div>
  );
}
